import { EditorHistoryGateway } from '@/editor/history/gateway'
import { useAppStore } from '@/stores/app'

let gateway: EditorHistoryGateway | null = null

/**
 * @returns 全局 `mockup` 编辑器历史网关（懒创建）
 */
export function getMockupEditorHistory(): EditorHistoryGateway {
  if (!gateway) {
    gateway = new EditorHistoryGateway(() => {
      try {
        return useAppStore().editorHistoryMaxSteps
      } catch {
        return 30
      }
    })
  }
  return gateway
}

/**
 * 测试用：重置网关实例。
 */
export function resetMockupEditorHistoryForTests(): void {
  gateway?.clear()
  gateway = null
}
